import { MAPBOX_TOKEN } from './geocode'

// Mapbox Static Images API — a plain image URL, not a live mapbox-gl instance.
// Fine for decorative/background use since it needs no WebGL and has no
// interactivity to fail at (see the map-component WebGL fallback rules in
// CLAUDE.md, which apply to `new mapboxgl.Map(...)` instances, not this).
export function churchMapBackgroundUrl(lat: number, lng: number, zoom = 12.5): string {
  const width = 1280
  const height = 640
  return `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/${lng},${lat},${zoom},0/${width}x${height}@2x?access_token=${MAPBOX_TOKEN}`
}
